import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-900 pt-20 pb-10 border-t border-charcoal-700" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-147">
          <div className="lg:col-span-1" data-id="element-148">
            <a href="#" className="inline-block mb-6" aria-label="Nexora Resume home" data-id="element-149">
              <img src="https://cdn.magicpatterns.com/uploads/w9WU4iE2GPyhrtXEUgkLSw/ChatGPT_Image_Jun_25,_2026,_07_14_34_PM.png" alt="Nexora Resume" className="h-28 w-auto object-contain" data-id="element-150" />
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-151">
              Premium executive resume writing and branding services for leaders
              who shape the future of corporate governance.
            </p>
          </div>

          <div data-id="element-152">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-153">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-154">
              <li data-id="element-155">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-156">
                  Board Resume Writing
                </a>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-158">
                  Executive Resumes
                </a>
              </li>
              <li data-id="element-159">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-160">
                  LinkedIn Branding
                </a>
              </li>
              <li data-id="element-161">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-162">
                  Executive Biographies
                </a>
              </li>
              <li data-id="element-163">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-164">
                  Board Positioning
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-165">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-166">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-167">
              <li data-id="element-168">
                <a href="#about" className="hover:text-gold transition-colors" data-id="element-169">
                  About Us
                </a>
              </li>
              <li data-id="element-170">
                <a href="#process" className="hover:text-gold transition-colors" data-id="element-171">
                  Our Process
                </a>
              </li>
              <li data-id="element-172">
                <a href="#testimonials" className="hover:text-gold transition-colors" data-id="element-173">
                  Success Stories
                </a>
              </li>
              <li data-id="element-174">
                <a href="#faq" className="hover:text-gold transition-colors" data-id="element-175">
                  FAQ
                </a>
              </li>
              <li data-id="element-176">
                <a href="#contact" className="hover:text-gold transition-colors" data-id="element-177">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-178">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-179">
              Contact
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-180">
              <li className="flex items-start" data-id="element-181">
                <Mail className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-182" />
                <a href="mailto:hello@nexoraresume.com" className="hover:text-white transition-colors" data-id="element-183">
                  hello@nexoraresume.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-184">
                <Phone className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-185" />
                <a href="tel:+18005550199" className="hover:text-white transition-colors" data-id="element-186">
                  +1 (800) 555-0199
                </a>
              </li>
              <li className="flex items-start" data-id="element-187">
                <MapPin className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-188" />
                <span data-id="element-189">
                  New York • London • Singapore
                  <br data-id="element-190" />
                  (Global Services)
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-191">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-192">
            &copy; {new Date().getFullYear()} Nexora Resume. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-193">
            <a href="#" className="hover:text-white transition-colors" data-id="element-194">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-195">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}